import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import Home from './components/Home.vue'
import About from './components/About.vue'
import Help from './components/Help.vue'
import Games from './components/Games.vue'
import Students from './components/Students.vue'
import Student from './components/Student.vue'
import Game from './components/Game.vue'
import GamesList from './components/GamesList.vue'
import Wordsearch from './components/Wordsearch.vue'
import RunawayRobot from './components/RunawayRobot.vue'
import MonsterCrossing from './components/MonsterCrossing.vue'

import '../public/css/app.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faPlayCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(VueRouter)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

library.add(faUserSecret, faPlayCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

//var basePath = 'http://3.145.14.80/';
var basePath = '/';

const routes = [
  { path: '/', component: Home },
  { path: '/about', name: 'About', component: About},
  { path: '/help', name: 'Help', component: Help},
  { path: '/students', name: 'Students', component: Students},
  { path: '/students/prek', name: 'prek', props:{grade: 'prek'}, component: Student},
  { path: '/students/1to3', name: '1to3', props:{grade: '1to3'}, component: Student},
  { path: '/students/4to6', name: '4to6', props:{grade: '4to6'}, component: Student},
  { path: '/students/7up', name: '7up', props:{grade: '7up'}, component: Student},
  { path: '/games', component: Games,
    children:[
      { path: '', component: GamesList },
      { path: 'wordsearch', component: Wordsearch },
      { path: 'mathmayhem', component: Game, props: {url: basePath+'games/mayhem/index.html'} },
      { path: 'wordmayhem', component: Game, props: {url: basePath+'games/wordmayhem/index.html', width: 740, height: 500} },
      { path: 'candycards', component: Game, props: {url: basePath+'games/candycards/index.html'} },
      { path: 'code13', component: Game, props: {url: basePath+'games/code13/index.html', width: 820, height: 620} },
      { path: 'countyourchickens', component: Game, props: {url: basePath+'games/cyc/index.html', width: 1024, height: 768}  },
      { path: 'galax', component: Game, props: {url: basePath+'games/galax/index.html', width: 820, height: 620} },
      { path: 'treasurehunt', component: Game, props: {url: basePath+'games/treasurehunt/index.html', width: 820, height: 620} },
      { path: 'traxx', component: Game, props: {url: basePath+'games/traxx/index.html'} },
      { path: 'skoolz', component: Game, props: {url: basePath+'games/skoolz/index.html', width: 820, height: 620} },
      { path: 'smarts', component: Game, props: {url: basePath+'games/smarts/index.html'} },
      { path: 'lunchbreak', component: Game, props: {url: basePath+'games/lb/index.html', width: 820, height: 620} },
      { path: 'runawayrobot', component: RunawayRobot },
      { path: 'runawayrobottraining', component: Game, props: {url: basePath+'games/launch.php?game=runawayrobot&id=ddf1a9d7-a324-41bb-a006-cf93b0b9d706', width:820, height: 620} },
      { path: 'runawayrobotkey', component: Game, props: {url: basePath+'games/launch.php?game=runawayrobot&id=a7dc7eb8-9f69-463f-a89e-f236e27f4316', width:820, height: 620} },
      { path: 'runawayrobotteleport', component: Game, props: {url: basePath+'games/launch.php?game=runawayrobot&id=3f32c196-677c-47f8-bb51-3cc58aabd274', width:820, height: 620} },
      { path: 'runawayrobotlocks', component: Game, props: {url: basePath+'games/launch.php?game=runawayrobot&id=a36cf864-cd6e-492d-9b8b-ccf2334c3b16', width:820, height: 620} },
      { path: 'aorder', component: Game, props: {url: basePath+'games/aorder/index.html', width: 820, height: 620} },
      { path: 'count', component: Game, props: {url: basePath+'games/count/index.html', width: 820, height: 620} },
      { path: '123order', component: Game, props: {url: basePath+'games/123_order/123index.html', width: 820, height: 620} },
      { path: 'abcorder', component: Game, props: {url: basePath+'games/123_order/abcindex.html', width: 820, height: 620} },
      { path: 'aact', component: Game, props: {url: basePath+'games/aact/index.html', width: 820, height: 620} },
      { path: 'maketime', component: Game, props: {url: basePath+'games/tw/maketime.html', width: 820, height: 620} },
      { path: 'settime', component: Game, props: {url: basePath+'games/tw/settime.html', width: 820, height: 620} },
      { path: 'telltime', component: Game, props: {url: basePath+'games/tw/telltime.html', width: 820, height: 620} },
      { path: 'playtime', component: Game, props: {url: basePath+'games/tw/playtime.html', width: 820, height: 620} },
      { path: 'chainlinks', component: Game, props: {url: basePath+'games/chainlinks/index.html', width: 820, height: 620} },
      { path: 'dws', component: Game, props: {url: basePath+'games/dws/index.html', width: 820, height: 620} },
      { path: 'dailyquiz', component: Game, props: {url: basePath+'games/dailyquiz/index.php', width: 820, height: 620} },
      { path: 'spaceymath', component: Game, props: {url: basePath+'games/sm/index.html', width: 820, height: 620} },
      { path: 'monstercrossing', component: MonsterCrossing },
      { path: 'monstercrossingadd', component: Game, props: {url: basePath+'games/launch.php?game=monstercrossing&id=e1315979-8f08-44b4-bbab-cf24b93b41f3', width:820, height: 620} },
      { path: 'monstercrossingsub', component: Game, props: {url: basePath+'games/launch.php?game=monstercrossing&id=f1e4f5ba-4295-4862-8934-3b19ec18758a', width:820, height: 620} },
      { path: 'monstercrossingmul', component: Game, props: {url: basePath+'games/launch.php?game=monstercrossing&id=15a49a29-dc20-4000-b02c-f97d8fe258af', width:820, height: 620} },
      { path: 'monstercrossingdiv', component: Game, props: {url: basePath+'games/launch.php?game=monstercrossing&id=c7a584a5-8403-4c92-bb04-50c2fb67e962', width:820, height: 620} },
      { path: 'dailysudoku', component: Game, props: {url: basePath+'games/sudoku/index.html', width: 820, height: 620} },
      { path: 'veggiewars', component: Game, props: {url: basePath+'games/vw/index.html', width: 820, height: 620} },
      { path: 'cliffhanger', component: Game, props: {url: basePath+'games/cliff/index.html', width: 820, height: 620} },
      { path: 'melcount', component: Game, props: {url: basePath+'games/melcount/index.html', width: 820, height: 620} },
      { path: 'hotshot', component: Game, props: {url: basePath+'games/hotshot/index.html', width: 820, height: 620} },
      { path: 'baseten', component: Game, props: {url: basePath+'games/base_ten/index.html', width: 820, height: 620} },
      { path: 'timecrime', component: Game, props: {url: basePath+'games/tc/index.html', width: 820, height: 620} },
      { path: 'pam', component: Game, props: {url: basePath+'games/pam/index.html', width: 820, height: 620} },
      { path: 'lemon', component: Game, props: {url: basePath+'games/lemon/index.html', width: 820, height: 620} }

    ]
  }
]

const router = new VueRouter({
  routes // short for `routes: routes`
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
